export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00238.738b3f26.png";